import { useT } from "@/context/ContentContext";

export default function HomeCuidado() {
    const t = useT();
    return (
        <section className="py-16 sm:py-24">
            <div className="max-w-4xl mx-auto px-6 sm:px-10 text-center">
                <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.05]">
                    {t("home.cuidado.line1", "A obra é nossa durante algum tempo.")}<br />
                    {t("home.cuidado.line2_before", "A")} <span className="font-serif-italic text-[hsl(var(--copper))]">{t("home.cuidado.line2_accent", "casa")}</span> {t("home.cuidado.line2_after", "continua a ser sua")}<span className="text-[hsl(var(--copper))]">.</span>
                </h2>
                <p className="text-[hsl(var(--graphite))]/70 text-lg mt-6 max-w-2xl mx-auto leading-relaxed">
                    {t("home.cuidado.text", "Trabalhar numa casa também significa proteger aquilo que não estamos a remodelar — zonas comuns, mobiliário existente, vizinhos, resíduos, poeiras e organização diária da obra.")}
                </p>
            </div>
        </section>
    );
}
